// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"52d4fc03","422":"ce985b16","711":"349b96c2"}[chunkId] + ".chunk.js";
};